@if(shouldShowWidget()) {
    <div class="px-survey-widget">
        <udex-button
            size="Medium"
            icon="sap-icon://feedback"
            design="Secondary"
            [attr.icon-only]="isIconOnly()"
            (click)="openSurvey()"
        >
            @if(!isIconOnly()) {
                Share feedback
            }
        </udex-button>
    </div>
}
